import { useGetBlobSasToken } from './useGetBlobSasToken'
import { BlobServiceClient } from '@azure/storage-blob'
import React from 'react'

export function useBlobStorage(blobContainerName: string) {
  const { refetch: fetchSasToken } = useGetBlobSasToken(blobContainerName)

  const getBlockBlobClient = React.useCallback(
    async (fileName: string) => {
      const { data } = await fetchSasToken()
      const { containerName, token, containerBaseURL } =
        data?.data.attributes || {}
      if (!containerName) {
        return
      }
      const blobServiceClient = new BlobServiceClient(
        `${containerBaseURL}?${token}`
      )
      const containerClient =
        blobServiceClient.getContainerClient(containerName)

      return containerClient.getBlockBlobClient(fileName)
    },
    [fetchSasToken]
  )

  return {
    getBlockBlobClient,
  }
}
